import { forwardRef, CSSProperties } from 'react';
import ModuleTitle, { ModuleTitleProps } from '@base/lib/ModuleTitle';
import titleStyles from 'app/styles/modules/title.module.less';
import { IThemeSwiperProps, ThemeSwiper } from '@base/lib/ThemeSwiper';
import { getFeatureTitleProps } from 'base/utils/features';
import { IFeature } from 'mod/feature/interface';
import cn from 'classnames';
import styles from './index.module.less';

type FeatureSwiperProps = {
    swiper: Omit<IThemeSwiperProps, 'list'>;
    'data-t-mod'?: string;
    id?: string;
    className?: string;
    style?: CSSProperties;
    data: Omit<Partial<IFeature>, 'lists'> & {
        lists: Array<any>
    };
    title?: false | ModuleTitleProps;
    isFetchedList?: boolean; // 列表数据以获取
}

const SwiperList = forwardRef<HTMLDivElement, FeatureSwiperProps>((props, ref) => {
    const {
        className,
        style,
        data,
        title,
        swiper,
        isFetchedList = true,
        'data-t-mod': moduleCode,
        ...rest
    } = props;
    const titleProps = getFeatureTitleProps(data as IFeature, title);

    return (
        <div
            data-t-mod={moduleCode}
            ref={ref}
            className={className}
            style={style}
            {...rest}
        >
            {titleProps && (
                <ModuleTitle
                    className={titleStyles.title}
                    {...titleProps}
                />
            )}

            {isFetchedList ? (
                <ThemeSwiper
                    navigation
                    navigationHideWhenDisabled
                    list={data.lists}
                    {...swiper}
                />
            ) : (
                <div className={cn(styles['g-empty-place'], 'g-empty-place')} />
            )}

        </div>
    );
});

const FeatureSwiper = forwardRef<HTMLDivElement, FeatureSwiperProps>((props, ref) => {
    return !props.data ? null : <SwiperList ref={ref} {...props}/>;
});

export default FeatureSwiper;